import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Chip,
  Paper,
  IconButton,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Select,
  MenuItem,
  Container,
  FormControl,
  Breadcrumbs,
  Tooltip,
  Avatar,
  Stack,
} from "@mui/material";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  ContentCopy,
  Download,
  Delete,
  CloudUpload,
  AutoFixHigh,
  Tune,
  Circle,
  Warning as WarningIcon,
  History as HistoryIcon,
  Save as SaveIcon,
  Psychology,
  Send,
  Edit,
} from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import InputBoxMui from "../ReusableComponents/InputBoxMui";
import FeatureButton from "../ReusableComponents/Button";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  checkCompression,
  checkExpansion,
  checkPhrasing,
} from "../../services/englishCheckers";
import Loader from "../../utils/loader";
import { connect } from "react-redux";
import adminServices from "../../services/adminServices";
import { useSelector } from "react-redux";
import { addUserLogs } from "../../services/userLogServices";
import { useCheckFeatureAccess } from "../CheckFeature";
import SubscriptionRequired from "../SubscriptionRequired";
import { useCheckSubscriptionPlanAccess } from "../SubscriptionAccess";
import { useHistory } from "react-router-dom";
import jwtDecode from "jwt-decode";
import Poetlogopen from "../../static/POET_Logo_Pen.png";
import { withStyles } from "@material-ui/core/styles";
import ParaphraseHistory from "./Summeriser/ParaphraseHistory";
import { saveParaphraseToHistory } from "../../../src/services/paraphraserHistoryService";
import { aiSmartDesk } from "../../services/aiIntelligenzServices";

const LightTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: "blue",
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
}))(Tooltip);

function NewParaphrase({ features, trial = false }) {
  const [inputText, setInputText] = useState("");
  const [outputText, setOutputText] = useState("");
  const userDetails = useSelector((state) => state.user);

  // History state
  const [historyOpen, setHistoryOpen] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [currentMachineId, setCurrentMachineId] = useState(null);

  // AI SmartDesk state
  // const [sdOpen, setSdOpen] = useState(false);
  // const [sdConv, setSdConv] = useState([]);
  // const [sdMsg, setSdMsg] = useState("");
  // const [sdLoading, setSdLoading] = useState(false);
  // const [sdEditingId, setSdEditingId] = useState(null);
  // const [sdEditContent, setSdEditContent] = useState("");
  // const [showSuccess, setShowSuccess] = useState(false);
  // const [successMessage, setSuccessMessage] = useState("");
  // const sdEndRef = useRef(null);
  // const sdGenId = () => Date.now().toString() + Math.random().toString(36).slice(2, 8);

  // Dark mode state
  // const [isDarkMode, setIsDarkMode] = useState(false);
  const token = sessionStorage.getItem("token");

  const getIdentityFromToken = () => {
    const token =
      sessionStorage.getItem("token") || localStorage.getItem("token");

    if (!token) return null;

    try {
      const decoded = jwtDecode(token);

      if (decoded.role === "guest") {
        return { machineId: decoded.machineId };
      } else {
        return { userId: decoded._id };
      }
    } catch (err) {
      console.error("Invalid token");
      return null;
    }
  };

  const identity = getIdentityFromToken();
  const [characters, setCharacters] = useState({ max: 1500, now: 0 });
  const [loading, setLoading] = useState(false);
  const [isParaphrase, setIsParaphrase] = useState(false);
  const [isCustomOpen, setIsCustomOpen] = useState(false);
  const [customText, setCustomText] = useState("Custom");
  const [customTextValue, setCustomTextValue] = useState("");
  const [selectedTone, setSelectedTone] = useState("standard");
  const [selectDropdownTone, setSelectDropdownTone] = useState("select");
  const [windowWidth, setWindowWidth] = useState(0);
  const [isClient, setIsClient] = useState(false);
  const history = useHistory();

  // State for word limit warning dialog
  const [wordLimitDialogOpen, setWordLimitDialogOpen] = useState(false);
  const [wordLimitExceeded, setWordLimitExceeded] = useState(false);

  // ── SmartDesk state ──
  const [sdOpen, setSdOpen] = useState(false);
  const [sdConv, setSdConv] = useState([]);
  const [sdMsg, setSdMsg] = useState("");
  const [sdLoading, setSdLoading] = useState(false);
  const [sdEditingId, setSdEditingId] = useState(null);
  const [sdEditContent, setSdEditContent] = useState("");
  const [showSuccess, setShowSuccess] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const sdEndRef = useRef(null);
  const sdGenId = () =>
    Date.now().toString() + Math.random().toString(36).slice(2, 8);

  // Dark mode state
  const [isDarkMode, setIsDarkMode] = useState(false);
  useEffect(() => {
    const updateTheme = () => {
      const theme = localStorage.getItem("ThemeSwitch");
      setIsDarkMode(theme === "true");
    };
    updateTheme();
    window.addEventListener("storage", updateTheme);
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments);
      if (key === "ThemeSwitch") {
        updateTheme();
      }
    };
    return () => {
      window.removeEventListener("storage", updateTheme);
      localStorage.setItem = originalSetItem;
    };
  }, []);

  const accessToUpload = useCheckFeatureAccess("paraphraser", "upload");
  const accessToParaphrase = useCheckFeatureAccess("paraphraser", "paraphrase");
  const accessToDelete = useCheckFeatureAccess("paraphraser", "delete");
  const accessToParaphraserScreen =
    useCheckSubscriptionPlanAccess("Paraphraser");
  const [subReqOpen, setSubReqOpen] = useState(false);

  const accessTocustom = true;
  const accessToTone = true;
  const accessToMoreOptions = true;

  const fileInputRef = useRef(null);

  const [suggestionText, setSuggestionText] = useState("Custom");
  const [isCustomSuggestion, setIsCustomSuggestion] = useState(true);

  const buttons = [
    { id: "standard", label: "Standard", icon: "📝" },
    { id: "formal", label: "Formal", icon: "🎩" },
    { id: "casual", label: "Casual", icon: "😊" },
    { id: "positive", label: "Positive", icon: "✨" },
    { id: "confident", label: "Confident", icon: "💪" },
    { id: "friendly", label: "Friendly", icon: "🤝" },
    { id: "simple", label: "Simple", icon: "🔹" },
  ];

  // Dark mode effect
  useEffect(() => {
    const updateTheme = () => {
      const theme = localStorage.getItem("ThemeSwitch");
      setIsDarkMode(theme === "true");
    };
    updateTheme();
    window.addEventListener("storage", updateTheme);
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments);
      if (key === "ThemeSwitch") {
        updateTheme();
      }
    };
    return () => {
      window.removeEventListener("storage", updateTheme);
      localStorage.setItem = originalSetItem;
    };
  }, []);

  // Set user identity for history
  useEffect(() => {
    const identity = getIdentityFromToken();
    if (identity) {
      setCurrentUserId(identity.userId);
      setCurrentMachineId(identity.machineId);
    }
  }, []);

  // SmartDesk scroll to bottom
  useEffect(() => {
    sdEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [sdConv, sdLoading]);

  // ── SmartDesk send ──
  // const sdSend = async (text) => {
  //   const txt = (text || sdMsg).trim();
  //   if (!txt || sdLoading) return;
  //   const userMsg = {
  //     id: sdGenId(),
  //     type: "user",
  //     content: txt,
  //     ts: new Date(),
  //   };
  //   const updated = [...sdConv, userMsg];
  //   setSdConv(updated);
  //   setSdMsg("");
  //   setSdLoading(true);
  //   try {
  //     const res = await aiSmartDesk(txt, "");
  //     const reply =
  //       res.data?.data?.response ||
  //       res.data?.response ||
  //       (typeof res.data === "string"
  //         ? res.data
  //         : "I couldn't parse that response.");
  //     setSdConv((prev) => [
  //       ...prev,
  //       { id: sdGenId(), type: "ai", content: reply, ts: new Date() },
  //     ]);
  //   } catch (e) {
  //     setSdConv((prev) => [
  //       ...prev,
  //       {
  //         id: sdGenId(),
  //         type: "ai",
  //         content: "Error: " + (e.message || "something went wrong"),
  //         ts: new Date(),
  //         isError: true,
  //       },
  //     ]);
  //   }
  //   setSdLoading(false);
  // };

  // ── SmartDesk save edit ──
  // const sdSaveEdit = async () => {
  //   if (!sdEditContent.trim()) {
  //     setSdEditingId(null);
  //     return;
  //   }
  //   const idx = sdConv.findIndex((m) => m.id === sdEditingId);
  //   if (idx === -1) {
  //     setSdEditingId(null);
  //     return;
  //   }
  //   const updated = sdConv.slice(0, idx);
  //   updated.push({
  //     ...sdConv[idx],
  //     content: sdEditContent.trim(),
  //     edited: true,
  //   });
  //   setSdConv(updated);
  //   setSdEditingId(null);
  //   setSdEditContent("");
  //   setSdLoading(true);
  //   try {
  //     const res = await aiSmartDesk(sdEditContent.trim(), "");
  //     const reply =
  //       res.data?.data?.response ||
  //       res.data?.response ||
  //       "Here is my revised response.";
  //     setSdConv((prev) => [
  //       ...prev,
  //       { id: sdGenId(), type: "ai", content: reply, ts: new Date() },
  //     ]);
  //   } catch (e) {
  //     setSdConv((prev) => [
  //       ...prev,
  //       {
  //         id: sdGenId(),
  //         type: "ai",
  //         content: "Error: " + e.message,
  //         ts: new Date(),
  //       },
  //     ]);
  //   }
  //   setSdLoading(false);
  // };

  //full screen layout
  // full screen layout
  useEffect(() => {
    document.body.style.margin = "0";
    document.body.style.padding = "0";
    document.body.style.height = "100vh";
    document.body.style.overflow = "hidden";
    document.documentElement.style.height = "100vh";
    document.documentElement.style.overflow = "hidden";

    return () => {
      document.body.style.margin = "";
      document.body.style.padding = "";
      document.body.style.height = "";
      document.body.style.overflow = "";
      document.documentElement.style.height = "";
      document.documentElement.style.overflow = "";
    };
  }, []);

  useEffect(() => {
    if (!inputText.trim()) {
      setSelectDropdownTone("select");
      setCustomText("Custom");
      setSelectedTone("standard");
    }
  }, [inputText]);

  useEffect(() => {
    setIsClient(true);
    setWindowWidth(window.innerWidth);

    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (
      !inputText.trim() &&
      (selectDropdownTone === "shorten" || selectDropdownTone === "expand")
    ) {
      setSelectDropdownTone("select");
    }
  }, [inputText, selectDropdownTone]);

  useEffect(() => {
    if (accessToParaphraserScreen === false) {
      setSubReqOpen(true);
    }
  }, [accessToParaphraserScreen]);

  useEffect(() => {
    if (isClient) {
      getParaphraseLimit();
    }
  }, [isClient]);

  // SmartDesk scroll to bottom
  useEffect(() => {
    sdEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [sdConv, sdLoading]);

  const getParaphraseLimit = async () => {
    try {
      let data = await adminServices.getParaphraseLimit();
      setCharacters({ max: data.paraphrase_limit, now: 0 });
    } catch (error) {
      console.error("Error getting paraphrase limit:", error);
      toast.error("Failed to load paraphrase limits");
    }
  };

  // ── SmartDesk send ──
  const sdSend = async (text) => {
    const txt = (text || sdMsg).trim();
    if (!txt || sdLoading) return;
    const userMsg = {
      id: sdGenId(),
      type: "user",
      content: txt,
      ts: new Date(),
    };
    const updated = [...sdConv, userMsg];
    setSdConv(updated);
    setSdMsg("");
    setSdLoading(true);
    try {
      const res = await aiSmartDesk(txt, "");
      const reply =
        res.data?.data?.response ||
        res.data?.response ||
        (typeof res.data === "string"
          ? res.data
          : "I couldn't parse that response.");
      setSdConv((prev) => [
        ...prev,
        { id: sdGenId(), type: "ai", content: reply, ts: new Date() },
      ]);
    } catch (e) {
      setSdConv((prev) => [
        ...prev,
        {
          id: sdGenId(),
          type: "ai",
          content: "Error: " + (e.message || "something went wrong"),
          ts: new Date(),
          isError: true,
        },
      ]);
    }
    setSdLoading(false);
  };

  // ── SmartDesk save edit ──
  const sdSaveEdit = async () => {
    if (!sdEditContent.trim()) {
      setSdEditingId(null);
      return;
    }
    const idx = sdConv.findIndex((m) => m.id === sdEditingId);
    if (idx === -1) {
      setSdEditingId(null);
      return;
    }
    const updated = sdConv.slice(0, idx);
    updated.push({
      ...sdConv[idx],
      content: sdEditContent.trim(),
      edited: true,
    });
    setSdConv(updated);
    setSdEditingId(null);
    setSdEditContent("");
    setSdLoading(true);
    try {
      const res = await aiSmartDesk(sdEditContent.trim(), "");
      const reply =
        res.data?.data?.response ||
        res.data?.response ||
        "Here is my revised response.";
      setSdConv((prev) => [
        ...prev,
        { id: sdGenId(), type: "ai", content: reply, ts: new Date() },
      ]);
    } catch (e) {
      setSdConv((prev) => [
        ...prev,
        {
          id: sdGenId(),
          type: "ai",
          content: "Error: " + e.message,
          ts: new Date(),
        },
      ]);
    }
    setSdLoading(false);
  };

  const handleInputChange = (event) => {
    const text = event.target.value;
    const length = text.length;

    if (length > characters.max) {
      toast.warn(
        `Character limit exceeded. Maximum ${characters.max} characters allowed.`
      );
      return;
    }

    setInputText(text);
    setCharacters({ ...characters, now: length });

    if (isParaphrase) {
      setIsParaphrase(false);
      setOutputText("");
    }
  };

  const GrammerCheckForParaphrase = async (type) => {
    setLoading(true);

    try {
      if (!inputText.trim()) {
        toast.warning("Please input some text!");
        setLoading(false);
        return;
      }

      let data = {
        text: inputText,
        isCoAuthor: false,
        ...identity,
      };

      if (type && type !== "defaultPrompt") {
        if (
          [
            "Like a story",
            "Like a poem",
            "Like a letter",
            "Like a sales executive",
            "Like a news",
            "Like a Doctor",
            "Like a CEO",
          ].includes(type)
        ) {
          data.tone = "custom";
          data.customTone = type;
        } else {
          data.tone = type;
        }
      }

      const paraphraseResponse = await checkPhrasing(data);

      if (paraphraseResponse && paraphraseResponse.data) {
        let outputText = "";

        if (Array.isArray(paraphraseResponse.data.output)) {
          outputText = paraphraseResponse.data.output.join("\n");
        } else if (typeof paraphraseResponse.data.output === "string") {
          outputText = paraphraseResponse.data.output;
        } else if (paraphraseResponse.data.paraphrasedText) {
          outputText = paraphraseResponse.data.paraphrasedText;
        } else if (paraphraseResponse.data.result) {
          outputText = paraphraseResponse.data.result;
        } else {
          outputText = JSON.stringify(paraphraseResponse.data);
        }

        if (outputText.startsWith("\n")) {
          outputText = outputText.substring(1);
        }

        setOutputText(outputText);
        setIsParaphrase(true);

        try {
          const logData = {
            ...identity,
            actionType: "paraphrase",
          };
          await addUserLogs(logData);
        } catch (logError) {
          console.error("Error logging user action:", logError);
        }

        toast.success("Text paraphrased successfully!");
      } else {
        toast.error("No valid response received from the server");
      }
    } catch (error) {
      console.error("Error in GrammerCheckForParaphrase:", error);
      toast.error("Failed to paraphrase text. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const checkWordsCompression = async () => {
    setLoading(true);
    try {
      if (!inputText.trim()) {
        toast.warning("Please input some text!");
        setLoading(false);
        return;
      }

      let data = {
        text: inputText,
        ...identity,
      };

      const wordCompressionResponse = await checkCompression(data);

      if (wordCompressionResponse && wordCompressionResponse.data) {
        let outputText = "";

        if (Array.isArray(wordCompressionResponse.data.output)) {
          outputText = wordCompressionResponse.data.output.join("\n");
        } else if (typeof wordCompressionResponse.data.output === "string") {
          outputText = wordCompressionResponse.data.output;
        } else {
          outputText = JSON.stringify(wordCompressionResponse.data);
        }

        if (outputText.startsWith("\n")) {
          outputText = outputText.substring(1);
        }

        setOutputText(outputText);
        setIsParaphrase(true);
        toast.success("Content has been shortened.");
      } else {
        toast.error("No response received for compression");
      }
    } catch (error) {
      console.error("Error in checkWordsCompression:", error);
      toast.error("Failed to compress text. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const checkWordsExpansion = async () => {
    setLoading(true);
    try {
      if (!inputText.trim()) {
        toast.warning("Please input some text!");
        setLoading(false);
        return;
      }

      let data = {
        text: inputText,
        ...identity,
      };

      const wordExpansionResponse = await checkExpansion(data);

      if (wordExpansionResponse && wordExpansionResponse.data) {
        let outputText = "";

        if (Array.isArray(wordExpansionResponse.data.output)) {
          outputText = wordExpansionResponse.data.output.join("\n");
        } else if (typeof wordExpansionResponse.data.output === "string") {
          outputText = wordExpansionResponse.data.output;
        } else {
          outputText = JSON.stringify(wordExpansionResponse.data);
        }

        if (outputText.startsWith("\n")) {
          outputText = outputText.substring(1);
        }

        setOutputText(outputText);
        setIsParaphrase(true);
        toast.success("The content has been enriched with more details.");
      } else {
        toast.error("No response received for expansion");
      }
    } catch (error) {
      console.error("Error in checkWordsExpansion:", error);
      toast.error("Failed to expand text. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const [isFeatureInside, setIsFeatureInside] = useState(false);

  // Save current paraphrase to history
  const handleSaveToHistory = async () => {
    if (!outputText.trim() || !inputText.trim()) {
      toast.warn("No paraphrased content to save");
      return;
    }
    
    try {
      const result = await saveParaphraseToHistory({
        userId: currentUserId || null,
        machineId: currentMachineId || null,
        originalText: inputText,
        outputText: outputText,
        toneType: selectedTone,
        customTone: selectedTone === "custom" ? customTextValue : "",
        mode: selectDropdownTone === "shorten" ? "shorten" : (selectDropdownTone === "expand" ? "expand" : "standard"),
        metadata: {
          processingTime: 0,
        },
        title: outputText.substring(0, 50),
      });
      
      if (result.success) {
        toast.success("Paraphrased content saved to history!");
      } else {
        toast.error("Failed to save to history");
      }
    } catch (error) {
      console.error("Error saving paraphrase:", error);
      toast.error("Failed to save to history");
    }
  };

  // Restore paraphrase from history
  const handleRestoreParaphrase = (paraphrasedText) => {
    setOutputText(paraphrasedText);
    setIsParaphrase(true);
    toast.success("Paraphrased content restored successfully!");
  };

  const handleFutureButton = async (type) => {
    const wordCount = countWords(inputText);

    if (wordCount > 1500) {
      setWordLimitDialogOpen(true);
      setWordLimitExceeded(true);
      return;
    }

    if (accessToMoreOptions == false) {
      setSubReqOpen(true);
      setIsFeatureInside(true);
      return;
    }
    try {
      if (accessTocustom == false) {
        setSubReqOpen(true);
        setIsFeatureInside(true);
        return;
      }

      if (!inputText.trim()) {
        toast.warning("Please input some text!");
        return;
      }

      if (type === "shorten") {
        await checkWordsCompression();
        setCustomText("Custom");
      } else if (type === "expand") {
        await checkWordsExpansion();
        setCustomText("Custom");
      } else if (type === "custom") {
        setIsCustomOpen(true);
      } else {
        await GrammerCheckForParaphrase(type);
        setCustomText("Custom");
      }
    } catch (error) {
      console.error("Error in handleFutureButton:", error);
      toast.error("An error occurred. Please try again.");
    }
  };

  const onPetAssistant = async () => {
    const wordCount = countWords(inputText);

    if (wordCount > 1500) {
      setWordLimitDialogOpen(true);
      setWordLimitExceeded(true);
      return;
    }

    try {
      if (!inputText.trim()) {
        toast.warning("Please input some text!");
        return;
      }

      await GrammerCheckForParaphrase("standard");
    } catch (error) {
      console.error("Error in onPetAssistant:", error);
      toast.error("An error occurred while processing your request.");
    }
  };

  const handleWordLimitDialogClose = () => {
    setWordLimitDialogOpen(false);
    setWordLimitExceeded(false);
  };

  const handleDelete1 = () => {
    setInputText("");
    setOutputText("");
    setIsParaphrase(false);
    setCharacters({ ...characters, now: 0 });
    setSelectDropdownTone("select");
    setCustomText("Custom");
    setSelectedTone("standard");
  };

  const handleDelete = () => {
    setOutputText("");
    setIsParaphrase(false);
  };

  const handleCopy = () => {
    if (!outputText.trim()) {
      toast.warn("No text to copy");
      return;
    }

    navigator.clipboard.writeText(outputText).then(
      () => {
        toast.success("Text copied to clipboard!");
      },
      (err) => {
        console.error("Could not copy text: ", err);
        toast.error("Failed to copy text");
      }
    );
  };

  const handleDownload = () => {
    if (!outputText.trim()) {
      toast.warn("No text to download");
      return;
    }

    const blob = new Blob([outputText], { type: "text/plain" });
    const anchor = document.createElement("a");
    anchor.href = URL.createObjectURL(blob);
    anchor.download = "paraphrased_text.txt";
    anchor.click();
    URL.revokeObjectURL(anchor.href);
    toast.success("File downloaded successfully!");
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.name.endsWith(".txt")) {
      toast.warn("Only .txt files are supported");
      return;
    }

    const reader = new FileReader();
    reader.onload = (event) => {
      const text = event.target.result;
      const wordCount = countWords(text);

      if (wordCount > 1500) {
        toast.warn("File content exceeds 1500 word limit");
        return;
      }

      setInputText(text);
      toast.success("File uploaded successfully!");
    };

    reader.onerror = () => {
      toast.error("Failed to read file");
    };

    reader.readAsText(file);
  };

  const handleCustomSelection = (type) => {
    if (!inputText.trim()) {
      toast.warning("Please input some text!");
      return;
    }

    GrammerCheckForParaphrase(type);
    setCustomText(type);
    setIsCustomOpen(false);
    setCustomTextValue("");
  };

  const handleCustomClick = () => {
    if (!customTextValue.trim()) {
      toast.warning("Please enter a custom tone");
      return;
    }

    handleCustomSelection(customTextValue);
  };

  const handleSuggestionChange = (e) => {
    setCustomTextValue(e.target.value);
  };

  const handleClose = () => {
    setIsCustomOpen(false);
    setCustomTextValue("");
  };
  const handleBreadcrumbClick = (event, path) => {
    event.preventDefault();
    window.location.href = "/docTags";
  };
  const handleToneClick = (toneId) => {
    if (accessToTone == false) {
      setSubReqOpen(true);
      setIsFeatureInside(true);
      return;
    }
    setSelectedTone(toneId);
    handleFutureButton(toneId);
  };

  const countWords = (text) => {
    return text.trim().length > 0 ? text.trim().split(/\s+/).length : 0;
  };

  const inputWordCount = countWords(inputText);
  const outputWordCount = countWords(outputText);

  const renderSelect = () => {
    if (!isClient) return null;

    return (
      <FormControl size="small" sx={{ minWidth: 100 }}>
        <Select
          value={selectDropdownTone}
          onChange={(e) => {
            const selectedValue = e.target.value;
            if (selectedValue !== "select") {
              handleFutureButton(selectedValue);
              setSelectedTone(selectedValue);
              setSelectDropdownTone(selectedValue);
            }
          }}
          displayEmpty
          sx={{
            borderRadius: 2,
            height: 36,
            "& .MuiSelect-select": {
              display: "flex",
              alignItems: "center",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                maxHeight: 300,
                "& .MuiMenuItem-root": {
                  minHeight: 36,
                  display: "flex",
                  alignItems: "center",
                },
              },
            },
          }}
        >
          <MenuItem value="select">More Options</MenuItem>
          <MenuItem
            disabled={!accessToParaphrase || !inputText.trim()}
            value="shorten"
          >
            🔽 Shorten
          </MenuItem>
          <MenuItem
            disabled={!accessToParaphrase || !inputText.trim()}
            value="expand"
          >
            🔼 Expand
          </MenuItem>
        </Select>
      </FormControl>
    );
  };

  if (!isClient) {
    return (
      <Box
        sx={{
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          background: "linear-gradient(135deg, #f5f7fa 0%, #e7ecf4ff 100%)",
          overflow: "hidden",
        }}
      >
        <Loader loading={true} />
      </Box>
    );
  }

  return (
    <>
      <SubscriptionRequired
        open={subReqOpen}
        setOpen={setSubReqOpen}
        isFeatureInside={isFeatureInside}
        setIsFeatureInside={setIsFeatureInside}
        path={"paraphrase"}
      />

      <Modal
        isOpen={isCustomOpen}
        toggle={handleClose}
        centered
        contentClassName="custom-style-modal"
      >
        <ModalBody className="p-0">
          <div className="style-header">
            <div className="style-title">✨ Transform Your Tone</div>
            <div className="style-subtitle">
              Choose a vibe or create your own
            </div>
            <button className="close-btn" onClick={handleClose}>
              ×
            </button>
          </div>

          <div className="style-content">
            <div className="custom-input-card">
              <InputBoxMui
                fullWidth
                placeholder='E.g., "like a News"'
                value={customTextValue}
                onChange={handleSuggestionChange}
              />
              <button
                className="apply-btn"
                onClick={handleCustomClick}
                disabled={!customTextValue}
              >
                Apply Style
              </button>
            </div>

            <div className="divider">
              <span>OR PICK A STYLE</span>
            </div>

            <div className="style-grid">
              <div
                className="style-pill"
                onClick={() => handleCustomSelection("Like a story")}
              >
                Storytelling
              </div>
              <div
                className="style-pill"
                onClick={() => handleCustomSelection("Like a poem")}
              >
                Poetic
              </div>
              <div
                className="style-pill"
                onClick={() => handleCustomSelection("Like a CEO")}
              >
                CEO Brief
              </div>
              <div
                className="style-pill"
                onClick={() => handleCustomSelection("Like a Doctor")}
              >
                Medical Expert
              </div>
              <div
                className="style-pill"
                onClick={() => handleCustomSelection("Like a news")}
              >
                Breaking News
              </div>
              <div
                className="style-pill"
                onClick={() => handleCustomSelection("Like a sales executive")}
              >
                Sales Pitch
              </div>
              <div
                className="style-pill"
                onClick={() => handleCustomSelection("Like a letter")}
              >
                Formal Letter
              </div>
              <div
                className={`style-pill ${isCustomSuggestion ? "disabled" : ""}`}
                onClick={() =>
                  !isCustomSuggestion && handleCustomSelection(suggestionText)
                }
              >
                {suggestionText}
              </div>
            </div>
          </div>

          <style jsx>{`
            .custom-style-modal {
              border-radius: 20px;
              overflow: hidden;
              backdrop-filter: blur(20px);
              background: rgba(255, 255, 255, 0.95);
            }
            .style-header {
              background: linear-gradient(135deg, #6366f1, #8b5cf6);
              color: white;
              padding: 24px;
              position: relative;
            }
            .style-title {
              font-size: 1.3rem;
              font-weight: 600;
              font-family: "Poppins", sans-serif;
            }
            .style-subtitle {
              font-size: 0.9rem;
              opacity: 0.85;
              margin-top: 4px;
              font-family: "Poppins", sans-serif;
            }
            .close-btn {
              position: absolute;
              right: 16px;
              top: 12px;
              border: none;
              background: transparent;
              font-size: 24px;
              color: white;
              cursor: pointer;
              padding: 4px 8px;
              border-radius: 50%;
              display: flex;
              align-items: center;
              justify-content: center;
              transition: background 0.2s ease;
            }
            .close-btn:hover {
              background: rgba(255, 255, 255, 0.2);
            }
            .style-content {
              padding: 24px;
            }
            .custom-input-card {
              display: flex;
              gap: 12px;
              margin-bottom: 20px;
            }
            .apply-btn {
              background: #6366f1;
              border: none;
              padding: 10px 18px;
              border-radius: 10px;
              color: white;
              font-weight: 500;
              transition: 0.2s ease;
              cursor: pointer;
              font-family: "Poppins", sans-serif;
              white-space: nowrap;
            }
            .apply-btn:hover:not(:disabled) {
              background: #4f46e5;
              transform: translateY(-2px);
            }
            .apply-btn:disabled {
              background: #a5b4fc;
              cursor: not-allowed;
              opacity: 0.6;
            }
            .divider {
              text-align: center;
              margin: 20px 0;
              font-size: 0.75rem;
              color: #888;
              position: relative;
              font-family: "Poppins", sans-serif;
              font-weight: 500;
            }
            .divider::before,
            .divider::after {
              content: "";
              position: absolute;
              height: 1px;
              width: 30%;
              background: #e5e7eb;
              top: 50%;
            }
            .divider::before {
              left: 0;
            }
            .divider::after {
              right: 0;
            }
            .style-grid {
              display: grid;
              grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
              gap: 12px;
            }
            .style-pill {
              padding: 12px;
              text-align: center;
              border-radius: 999px;
              background: #f3f4f6;
              cursor: pointer;
              font-weight: 500;
              transition: 0.2s ease;
              font-family: "Poppins", sans-serif;
              font-size: 0.9rem;
              color: #303030;
              border: 1px solid transparent;
            }
            .style-pill:hover:not(.disabled) {
              background: #e0e7ff;
              transform: scale(1.03);
              border-color: #6366f1;
            }
            .style-pill.disabled {
              opacity: 0.5;
              cursor: not-allowed;
              background: #f3f4f6;
            }
            @media (max-width: 480px) {
              .style-grid {
                grid-template-columns: repeat(2, 1fr);
              }
              .custom-input-card {
                flex-direction: column;
              }
              .apply-btn {
                width: 100%;
              }
            }
          `}</style>
        </ModalBody>
      </Modal>

      {/* Word Limit Warning Dialog */}
      <Dialog
        open={wordLimitDialogOpen}
        onClose={handleWordLimitDialogClose}
        aria-labelledby="word-limit-dialog-title"
        aria-describedby="word-limit-dialog-description"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: 3,
            padding: 2,
            minWidth: 400,
          },
        }}
      >
        <DialogTitle
          id="word-limit-dialog-title"
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            color: "#ef4444",
            fontWeight: 600,
          }}
        >
          <WarningIcon sx={{ fontSize: 28 }} />
          Word Limit Exceeded
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="word-limit-dialog-description"
            sx={{ color: "#4b5563", fontSize: "1rem" }}
          >
            You have entered <strong>{inputWordCount}</strong> words, which
            exceeds the maximum limit of <strong>1500 words</strong>.
          </DialogContentText>
          <Box sx={{ mt: 2, p: 2, bgcolor: "#f3f4f6", borderRadius: 2 }}>
            <Typography variant="body2" sx={{ color: "#1f2937" }}>
              Please reduce your text to 1500 words or less to continue with
              paraphrasing.
            </Typography>
          </Box>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Button
            onClick={handleWordLimitDialogClose}
            variant="contained"
            sx={{
              bgcolor: "#ef4444",
              "&:hover": { bgcolor: "#dc2626" },
              borderRadius: 2,
              px: 4,
            }}
          >
            OK, Got it
          </Button>
        </DialogActions>
      </Dialog>

      {/* <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      /> */}

      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          background: isDarkMode
            ? "linear-gradient(135deg, #000000 0%, #000000 100%)"
            : "linear-gradient(135deg, #f5f7fa 0%, #ffffff 100%)",
        }}
      >
        <Loader loading={loading} />
        <Container
          maxWidth={false}
          disableGutters
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
            px: 2,
            py: 1.5,
          }}
        >
          {/* Header */}
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              position: "relative",
              width: "100%",
              mb: 1.5,
              flexShrink: 0,
            }}
          >
            {/* LEFT SIDE - Breadcrumb */}
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Paper
                elevation={1}
                sx={{
                  p: 1.5,
                  bgcolor: "white",
                  borderRadius: 3,
                  border: "1px solid",
                  borderColor: "divider",
                  transition: "all 0.3s ease",
                  "&:hover": {
                    boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
                  },
                }}
              >
                <Breadcrumbs
                  separator={
                    <NavigateNextIcon
                      fontSize="small"
                      sx={{ color: "#667eea" }}
                    />
                  }
                  aria-label="breadcrumb"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "nowrap",
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Box
                      sx={{
                        bgcolor: "white",
                        borderRadius: 2,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: 32,
                        height: 32,
                        mr: 2,
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                      }}
                    >
                      <img
                        alt="logo"
                        src={Poetlogopen}
                        style={{
                          height: "28px",
                          width: "28px",
                          objectFit: "contain",
                          bgcolor: "white",
                          filter:
                            "drop-shadow(0 0 7px rgba(163, 163, 164, 0.65))",
                        }}
                      />
                    </Box>
                    <AutoFixHigh sx={{ fontSize: 20, color: "#667eea" }} />

                    <Link
                      to="/docTags"
                      onClick={(e) => handleBreadcrumbClick(e, "/docTags")}
                      style={{
                        textDecoration: "none",
                        color: "#667eea",
                        fontWeight: 500,
                        fontSize: "0.95rem",
                        padding: "4px 8px",
                        borderRadius: "6px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      MultiTool AI
                    </Link>

                    <NavigateNextIcon
                      fontSize="small"
                      sx={{ color: "#667eea" }}
                    />

                    <Typography
                      sx={{
                        color: "#1a1a1a",
                        fontWeight: 600,
                        fontSize: "0.95rem",
                        padding: "4px 8px",
                        borderRadius: "6px",
                        backgroundColor: "rgba(102, 126, 234, 0.08)",
                        whiteSpace: "nowrap",
                      }}
                    >
                      AI Paraphraser
                    </Typography>
                  </Box>
                </Breadcrumbs>
              </Paper>
            </Box>

            {/* CENTER CONTENT */}
            <Box
              sx={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
                textAlign: "center",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <AutoFixHigh sx={{ fontSize: 36, color: "primary.main" }} />
                <Box>
                  <Typography
                    sx={{
                      fontSize: 22,
                      fontWeight: 700,
                      color: "primary.main",
                    }}
                  >
                    AI Paraphraser
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{ color: "text.secondary", fontStyle: "italic" }}
                  >
                    Transform your text with intelligent rephrasing powered by
                    AI
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* RIGHT SIDE - History Button (moved left to avoid AI SmartDesk FAB) */}
            <Box sx={{ mr: 14 }}>
              <Tooltip title="View History">
                <Button
                  variant="outlined"
                  startIcon={<HistoryIcon />}
                  onClick={() => setHistoryOpen(true)}
                  sx={{
                    borderRadius: 2,
                    borderColor: "#10b981",
                    color: "#10b981",
                    "&:hover": {
                      borderColor: "#059669",
                      backgroundColor: "rgba(16, 185, 129, 0.1)",
                    },
                  }}
                >
                  History
                </Button>
              </Tooltip>
            </Box>
          </Box>

          {/* Tone Selection Bar */}
          <Box sx={{ flexShrink: 0, mb: 1.5 }}>
            <Card
              elevation={0}
              sx={{
                borderRadius: 3,
                background: isDarkMode
                  ? "rgba(30, 41, 59, 0.95)"
                  : "rgba(255, 255, 255, 0.95)",
                backdropFilter: "blur(10px)",
                border: isDarkMode ? "1px solid #475569" : "1px solid rgba(255, 255, 255, 0.3)",
              }}
            >
              <CardContent sx={{ pb: 2, "&:last-child": { pb: 2 } }}>
                <Box sx={{ mb: 1 }}>
                  <Typography variant="subtitle1" fontWeight={600} sx={{ color: isDarkMode ? "white" : "inherit" }}>
                    Output Format
                  </Typography>
                  <Typography variant="caption" sx={{ color: isDarkMode ? "#94a3b8" : "inherit" }}>
                    Select how you want to display the paraphrased content
                  </Typography>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: 1.5,
                    alignItems: "center",
                    minHeight: 40,
                  }}
                >
                  {buttons.map((button) => (
                    <Chip
                      key={button.id}
                      icon={
                        <span style={{ fontSize: "16px" }}>{button.icon}</span>
                      }
                      label={button.label}
                      disabled={!inputText || !accessToParaphrase}
                      onClick={() => handleToneClick(button.id)}
                      color={selectedTone === button.id ? "primary" : "default"}
                      variant={
                        selectedTone === button.id ? "filled" : "outlined"
                      }
                      sx={{
                        height: "36px",
                        fontSize: "0.85rem",
                        fontWeight: 600,
                        transition: "all 0.3s",
                        cursor: "pointer",
                        "&:hover": { transform: "scale(1.05)", boxShadow: 2 },
                      }}
                    />
                  ))}

                  <Box
                    sx={{
                      ml: "auto",
                      display: "flex",
                      gap: 1,
                      flexWrap: "wrap",
                      alignItems: "center",
                    }}
                  >
                    {renderSelect()}

                    <Button
                      variant="contained"
                      onClick={() => handleFutureButton("custom")}
                      disabled={!accessToParaphrase || !inputText.trim()}
                      startIcon={<Tune />}
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        height: 36,
                        minWidth: 100,
                        background:
                          inputWordCount > 1500
                            ? "#ef4444"
                            : "linear-gradient(45deg, #667eea, #764ba2)",
                        "&:hover": {
                          background:
                            inputWordCount > 1500
                              ? "#dc2626"
                              : "linear-gradient(45deg, #764ba2, #667eea)",
                        },
                      }}
                    >
                      {customText}
                    </Button>
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Box>

          {/* Main content area */}
          <Box sx={{ flex: 1, minHeight: 0, width: "100%" }}>
            <Box
              sx={{
                display: "grid",
                gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                gap: 3,
                height: "100%",
              }}
            >
              {/* Input Card */}
              <Card
                elevation={4}
                sx={{
                  height: "100%",
                  borderRadius: 3,
                  background: isDarkMode
                    ? "rgba(30, 41, 59, 0.95)"
                    : "linear-gradient(145deg, #ffffff 0%, #f8f9fa 100%)",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  color: isDarkMode ? "white" : "inherit",
                }}
              >
                <Box
                  sx={{
                    bgcolor: "primary.main",
                    color: "white",
                    p: 2,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    flexShrink: 0,
                  }}
                >
                  <Typography
                    variant="subtitle1"
                    sx={{ fontWeight: 600, flexGrow: 1 }}
                  >
                    📝 Input Text
                  </Typography>
                  <Chip
                    label={`${inputWordCount} Words`}
                    size="small"
                    sx={{
                      bgcolor:
                        inputWordCount > 1500
                          ? "#ef4444"
                          : "rgba(255,255,255,0.2)",
                      color: "white",
                      fontWeight: 600,
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    flex: 1,
                    minHeight: 0,
                    p: 2,
                    overflow: "auto",
                    "&::-webkit-scrollbar": { width: "8px" },
                    "&::-webkit-scrollbar-track": {
                      background: "#f5f5f5",
                      borderRadius: "4px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#c1c1c1",
                      borderRadius: "4px",
                      "&:hover": { background: "#a8a8a8" },
                    },
                  }}
                >
                  <TextField
                    multiline
                    fullWidth
                    value={inputText}
                    onChange={handleInputChange}
                    placeholder="✨ Start typing or paste your text here to paraphrase..."
                    variant="outlined"
                    InputProps={{
                      sx: {
                        fontSize: "15px",
                        lineHeight: 1.6,
                        height: "100%",
                        color: isDarkMode ? "white" : "inherit",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                      },
                    }}
                    sx={{
                      height: "100%",
                      "& .MuiInputBase-root": {
                        height: "100%",
                        alignItems: "flex-start",
                      },
                      "& textarea": {
                        height: "100% !important",
                        overflow: "auto !important",
                        resize: "none",
                      },
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    p: 2,
                    bgcolor: isDarkMode ? "#1e293b" : "black.50",
                    borderTop: "1px solid",
                    borderColor: "divider",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexShrink: 0,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Circle
                      sx={{
                        fontSize: 10,
                        color:
                          inputWordCount > 1500 ? "error.main" : "success.main",
                      }}
                    />
                    <Typography
                      variant="caption"
                      sx={{ fontWeight: 600, color: "text.secondary" }}
                    >
                      {inputWordCount} / 1500 Words
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                    <Button
                      component="label"
                      variant="outlined"
                      size="small"
                      disabled={!accessToUpload}
                      startIcon={<CloudUpload />}
                      sx={{ borderRadius: 2, textTransform: "none" }}
                    >
                      Upload
                      <input
                        ref={fileInputRef}
                        type="file"
                        accept=".txt"
                        hidden
                        onChange={handleFileUpload}
                      />
                    </Button>

                    <Button
                      variant="contained"
                      size="small"
                      onClick={onPetAssistant}
                      disabled={!inputText || !accessToParaphrase}
                      startIcon={<AutoFixHigh />}
                      sx={{
                        borderRadius: 2,
                        textTransform: "none",
                        fontWeight: 600,
                        background:
                          inputWordCount > 1500
                            ? "#ef4444"
                            : "linear-gradient(45deg, #667eea, #764ba2)",
                        "&:hover": {
                          background:
                            inputWordCount > 1500
                              ? "#dc2626"
                              : "linear-gradient(45deg, #764ba2, #667eea)",
                        },
                      }}
                    >
                      {!isParaphrase ? "Paraphrase" : "Re-Phrase"}
                    </Button>
                    <LightTooltip title="Clear Input">
                      <IconButton
                        size="small"
                        onClick={handleDelete1}
                        disabled={!accessToDelete}
                        sx={{
                          color: accessToDelete ? "error.main" : "black.500",
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </LightTooltip>
                  </Box>
                </Box>
              </Card>

              {/* Output Card */}
              <Card
                elevation={4}
                sx={{
                  height: "100%",
                  borderRadius: 3,
                  background: isDarkMode
                    ? "rgba(30, 41, 59, 0.95)"
                    : "linear-gradient(145deg, #ffffff 0%, #e8f5e9 100%)",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  color: isDarkMode ? "white" : "inherit",
                }}
              >
                <Box
                  sx={{
                    bgcolor: "success.main",
                    color: "white",
                    p: 2,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexShrink: 0,
                  }}
                >
                  <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                    ✨ Paraphrased Result
                  </Typography>
                  <Chip
                    label={`${outputWordCount} Words`}
                    size="small"
                    sx={{
                      bgcolor: "rgba(255,255,255,0.2)",
                      color: "white",
                      fontWeight: 600,
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    flex: 1,
                    minHeight: 0,
                    p: 2,
                    overflow: "auto",
                    "&::-webkit-scrollbar": { width: "8px" },
                    "&::-webkit-scrollbar-track": {
                      background: "#f5f5f5",
                      borderRadius: "4px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#c1c1c1",
                      borderRadius: "4px",
                      "&:hover": { background: "#a8a8a8" },
                    },
                  }}
                >
                  <TextField
                    multiline
                    fullWidth
                    value={outputText}
                    placeholder="Your paraphrased text will appear here..."
                    variant="outlined"
                    InputProps={{
                      readOnly: true,
                      sx: {
                        fontSize: "15px",
                        lineHeight: 1.6,
                        height: "100%",
                        color: isDarkMode ? "white" : "inherit",
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },
                      },
                    }}
                    sx={{
                      height: "100%",
                      "& .MuiInputBase-root": {
                        height: "100%",
                        alignItems: "flex-start",
                      },
                      "& textarea": {
                        height: "100% !important",
                        overflow: "auto !important",
                        resize: "none",
                      },
                    }}
                  />
                </Box>

                <Box
                  sx={{
                    p: 2,
                    bgcolor: isDarkMode ? "#1e293b" : "black.50",
                    borderTop: "1px solid",
                    borderColor: "divider",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexShrink: 0,
                  }}
                >
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Circle sx={{ fontSize: 10, color: "success.main" }} />
                    <Typography
                      variant="caption"
                      sx={{ fontWeight: 600, color: "text.secondary" }}
                    >
                      {outputWordCount} Words Generated
                    </Typography>
                  </Box>

                  <Box sx={{ display: "flex", gap: 1 }}>
                    <LightTooltip title="Save to History">
                      <IconButton
                        size="small"
                        onClick={handleSaveToHistory}
                        disabled={!outputWordCount}
                        sx={{
                          color: outputWordCount ? "#f59e0b" : "black.500",
                        }}
                      >
                        <SaveIcon />
                      </IconButton>
                    </LightTooltip>
                    <LightTooltip title="Download">
                      <IconButton
                        size="small"
                        onClick={handleDownload}
                        disabled={!outputWordCount}
                        sx={{
                          color: outputWordCount ? "success.main" : "black.500",
                        }}
                      >
                        <Download />
                      </IconButton>
                    </LightTooltip>
                    <LightTooltip title="Copy Content">
                      <IconButton
                        size="small"
                        onClick={handleCopy}
                        disabled={!outputWordCount}
                        sx={{
                          color: outputWordCount ? "info.main" : "black.500",
                        }}
                      >
                        <ContentCopy />
                      </IconButton>
                    </LightTooltip>
                    <LightTooltip title="Clear Output">
                      <IconButton
                        size="small"
                        onClick={handleDelete}
                        disabled={!accessToDelete || !outputWordCount}
                        sx={{
                          color:
                            accessToDelete && outputWordCount
                              ? "error.main"
                              : "black.500",
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </LightTooltip>
                  </Box>
                </Box>
              </Card>
            </Box>
          </Box>
        </Container>

        {/* History Drawer */}
        <ParaphraseHistory
          open={historyOpen}
          onClose={() => setHistoryOpen(false)}
          onRestoreParaphrase={handleRestoreParaphrase}
          userId={currentUserId}
          machineId={currentMachineId}
        />

        {/* ── Wave FAB for AI SmartDesk ── */}
        <Box
          sx={{
            position: "fixed",
            top: 30,
            right: 28,
            width: 60,
            height: 60,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1400,
          }}
        >
          {[0, 1, 2].map((i) => (
            <Box
              key={i}
              sx={{
                position: "absolute",
                width: 60,
                height: 60,
                borderRadius: "50%",
                border: "2.5px solid rgba(102,126,234,0.5)",
                animation: "sdWave 2s ease-out infinite",
                animationDelay: `${i * 0.6}s`,
                "@keyframes sdWave": {
                  "0%": { transform: "scale(1)", opacity: 0.8 },
                  "100%": { transform: "scale(2.3)", opacity: 0 },
                },
              }}
            />
          ))}
          <LightTooltip title="AI SmartDesk" placement="left">
            <Box
              onClick={() => setSdOpen(true)}
              sx={{
                position: "relative",
                zIndex: 2,
                width: 60,
                height: 60,
                borderRadius: "50%",
                background: "linear-gradient(135deg,#667eea,#764ba2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                animation: "sdPulse 3s ease-in-out infinite",
                "@keyframes sdPulse": {
                  "0%,100%": { transform: "scale(1)" },
                  "50%": { transform: "scale(1.07)" },
                },
                "&:hover": {
                  transform: "scale(1.12) !important",
                  boxShadow: "0 8px 24px rgba(102,126,234,0.5)",
                },
                transition: "box-shadow .2s",
              }}
            >
              <Psychology sx={{ color: "white", fontSize: 28 }} />
            </Box>
          </LightTooltip>
        </Box>

        {/* ── AI SmartDesk Center Dialog ── */}
        <Dialog
          open={sdOpen}
          onClose={() => {
            setSdOpen(false);
            setSdEditingId(null);
          }}
          maxWidth={false}
          PaperProps={{
            sx: {
              width: 480,
              height: 600,
              borderRadius: 4,
              display: "flex",
              flexDirection: "column",
              overflow: "hidden",
              background: isDarkMode ? "#1e293b" : "#fff",
              boxShadow: "0 32px 80px rgba(0,0,0,0.22)",
            },
          }}
        >
          {/* Header */}
          <Box
            sx={{
              px: 2,
              py: 1.5,
              background: "linear-gradient(135deg,#667eea,#764ba2)",
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              flexShrink: 0,
            }}
          >
            <Avatar
              sx={{ bgcolor: "rgba(255,255,255,0.2)", width: 38, height: 38 }}
            >
              <Psychology sx={{ fontSize: 22, color: "white" }} />
            </Avatar>
            <Box sx={{ flex: 1 }}>
              <Typography
                variant="subtitle1"
                sx={{
                  color: "white",
                  fontWeight: 600,
                  lineHeight: 1.2,
                  fontSize: "0.9rem",
                }}
              >
                AI SmartDesk
              </Typography>
              <Typography
                variant="caption"
                sx={{
                  color: "rgba(255,255,255,0.85)",
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                }}
              >
                <Box
                  sx={{
                    width: 7,
                    height: 7,
                    borderRadius: "50%",
                    bgcolor: "#4ade80",
                    display: "inline-block",
                  }}
                />
                Online · Ready to assist
              </Typography>
            </Box>
            <IconButton
              size="small"
              onClick={() => {
                setSdOpen(false);
                setSdEditingId(null);
              }}
              sx={{
                bgcolor: "rgba(255,255,255,0.18)",
                color: "white",
                "&:hover": { bgcolor: "rgba(255,255,255,0.3)" },
                width: 30,
                height: 30,
              }}
            >
              <CloseIcon sx={{ fontSize: 15 }} />
            </IconButton>
          </Box>

          {/* Messages */}
          <Box
            sx={{
              flex: 1,
              overflowY: "auto",
              p: 1.75,
              display: "flex",
              flexDirection: "column",
              gap: 1.5,
              bgcolor: isDarkMode ? "#0f172a" : "#f8fafc",
              "&::-webkit-scrollbar": { width: 4 },
              "&::-webkit-scrollbar-thumb": {
                bgcolor: "rgba(102,126,234,0.25)",
                borderRadius: 4,
              },
            }}
          >
            {sdConv.length === 0 && !sdLoading ? (
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 1.5,
                  textAlign: "center",
                  py: 3,
                  minHeight: 320,
                }}
              >
                <Box
                  sx={{
                    width: 58,
                    height: 58,
                    borderRadius: 3,
                    bgcolor: "rgba(102,126,234,0.09)",
                    border: "1px solid rgba(102,126,234,0.18)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Psychology sx={{ fontSize: 28, color: "#667eea" }} />
                </Box>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 600,
                    color: isDarkMode ? "white" : "#0f172a",
                  }}
                >
                  Hello! I'm your AI assistant
                </Typography>
                <Typography
                  variant="caption"
                  sx={{ color: "#64748b", maxWidth: 210, lineHeight: 1.6 }}
                >
                  Ask me anything or pick a quick prompt
                </Typography>
              </Box>
            ) : (
              sdConv.map((msg) => {
                const isUser = msg.type === "user";
                const isEditing = sdEditingId === msg.id;
                return (
                  <Box
                    key={msg.id}
                    sx={{
                      display: "flex",
                      justifyContent: isUser ? "flex-end" : "flex-start",
                      gap: 1,
                      alignItems: "flex-end",
                    }}
                  >
                    {!isUser && (
                      <Avatar
                        sx={{
                          width: 28,
                          height: 28,
                          bgcolor: "#764ba2",
                          fontSize: "0.62rem",
                          fontWeight: 700,
                        }}
                      >
                        AI
                      </Avatar>
                    )}
                    <Box sx={{ maxWidth: "72%" }}>
                      <Paper
                        elevation={0}
                        sx={{
                          px: 1.5,
                          py: 1,
                          fontSize: "0.8rem",
                          lineHeight: 1.65,
                          whiteSpace: "pre-wrap",
                          borderRadius: isUser
                            ? "14px 4px 14px 14px"
                            : "4px 14px 14px 14px",
                          background: isUser
                            ? "linear-gradient(135deg,#667eea,#764ba2)"
                            : isDarkMode
                            ? "#1e293b"
                            : "#fff",
                          color: isUser
                            ? "white"
                            : isDarkMode
                            ? "#e2e8f0"
                            : "#0f172a",
                          border: !isUser
                            ? `0.5px solid ${
                                isDarkMode ? "#334155" : "rgba(0,0,0,0.09)"
                              }`
                            : "none",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontSize: "0.8rem",
                            lineHeight: 1.65,
                            whiteSpace: "pre-wrap",
                          }}
                        >
                          {msg.content}
                          {msg.edited && (
                            <Box
                              component="span"
                              sx={{
                                fontSize: "0.65rem",
                                color: isUser
                                  ? "rgba(255,255,255,0.7)"
                                  : "#f59e0b",
                                ml: 0.5,
                              }}
                            >
                              (edited)
                            </Box>
                          )}
                        </Typography>
                      </Paper>

                      {/* Edit box for user msgs */}
                      {isEditing && (
                        <Box
                          sx={{
                            mt: 0.75,
                            p: 1.25,
                            bgcolor: "#fffbf0",
                            border: "1px solid #fcd34d",
                            borderRadius: 2,
                          }}
                        >
                          <TextField
                            fullWidth
                            multiline
                            rows={3}
                            size="small"
                            value={sdEditContent}
                            onChange={(e) => setSdEditContent(e.target.value)}
                            sx={{
                              mb: 1,
                              "& .MuiOutlinedInput-root": {
                                fontSize: "0.78rem",
                                borderRadius: 2,
                              },
                            }}
                          />
                          <Stack
                            direction="row"
                            spacing={0.75}
                            justifyContent="flex-end"
                          >
                            <Button
                              size="small"
                              onClick={() => {
                                setSdEditingId(null);
                                setSdEditContent("");
                              }}
                              sx={{
                                fontSize: "0.72rem",
                                color: "#64748b",
                                borderColor: "rgba(0,0,0,0.15)",
                              }}
                              variant="outlined"
                            >
                              Cancel
                            </Button>
                            <Button
                              size="small"
                              onClick={sdSaveEdit}
                              variant="contained"
                              sx={{
                                fontSize: "0.72rem",
                                background: "#667eea",
                                "&:hover": { background: "#5a6fd6" },
                              }}
                            >
                              Save & resend
                            </Button>
                          </Stack>
                        </Box>
                      )}

                      <Typography
                        variant="caption"
                        sx={{
                          fontSize: "0.65rem",
                          color: "#94a3b8",
                          display: "block",
                          mt: 0.3,
                          textAlign: isUser ? "right" : "left",
                        }}
                      >
                        {msg.ts.toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </Typography>

                      {/* Action icons */}
                      <Box
                        sx={{
                          display: "flex",
                          gap: 0.5,
                          mt: 0.4,
                          justifyContent: isUser ? "flex-end" : "flex-start",
                          opacity: 0,
                          transition: "opacity .15s",
                          "&:hover": { opacity: 1 },
                        }}
                      >
                        {isUser && (
                          <LightTooltip title="Edit message">
                            <IconButton
                              size="small"
                              onClick={() => {
                                setSdEditingId(msg.id);
                                setSdEditContent(msg.content);
                              }}
                              sx={{
                                width: 24,
                                height: 24,
                                borderRadius: 1,
                                bgcolor: "rgba(102,126,234,0.1)",
                                "&:hover": {
                                  bgcolor: "rgba(102,126,234,0.22)",
                                },
                              }}
                            >
                              <Edit sx={{ fontSize: 13, color: "#667eea" }} />
                            </IconButton>
                          </LightTooltip>
                        )}
                        <LightTooltip
                          title={isUser ? "Copy message" : "Copy response"}
                        >
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              navigator.clipboard.writeText(msg.content);
                              const btn = e.currentTarget;
                              btn.style.background = "rgba(16,185,129,0.2)";
                              setTimeout(
                                () => (btn.style.background = ""),
                                1800
                              );
                              setSuccessMessage(
                                isUser ? "Message copied!" : "Response copied!"
                              );
                              setShowSuccess(true);
                            }}
                            sx={{
                              width: 24,
                              height: 24,
                              borderRadius: 1,
                              bgcolor: "rgba(16,185,129,0.1)",
                              "&:hover": { bgcolor: "rgba(16,185,129,0.22)" },
                            }}
                          >
                            <ContentCopy
                              sx={{ fontSize: 13, color: "#10b981" }}
                            />
                          </IconButton>
                        </LightTooltip>
                      </Box>
                    </Box>
                    {isUser && (
                      <Avatar
                        sx={{
                          width: 28,
                          height: 28,
                          bgcolor: "#667eea",
                          fontSize: "0.62rem",
                          fontWeight: 700,
                        }}
                      >
                        U
                      </Avatar>
                    )}
                  </Box>
                );
              })
            )}

            {sdLoading && (
              <Box sx={{ display: "flex", gap: 1, alignItems: "flex-end" }}>
                <Avatar
                  sx={{
                    width: 28,
                    height: 28,
                    bgcolor: "#764ba2",
                    fontSize: "0.62rem",
                    fontWeight: 700,
                  }}
                >
                  AI
                </Avatar>
                <Paper
                  elevation={0}
                  sx={{
                    px: 1.5,
                    py: 1,
                    borderRadius: "4px 14px 14px 14px",
                    bgcolor: isDarkMode ? "#1e293b" : "#fff",
                    border: `0.5px solid ${
                      isDarkMode ? "#334155" : "rgba(0,0,0,0.09)"
                    }`,
                  }}
                >
                  <Box sx={{ display: "flex", gap: 0.6, alignItems: "center" }}>
                    {[0, 1, 2].map((i) => (
                      <Box
                        key={i}
                        sx={{
                          width: 7,
                          height: 7,
                          borderRadius: "50%",
                          bgcolor: "#a855f7",
                          animation: "sdBounce 1.2s infinite",
                          animationDelay: `${i * 0.18}s`,
                          "@keyframes sdBounce": {
                            "0%,60%,100%": { transform: "translateY(0)" },
                            "30%": { transform: "translateY(-5px)" },
                          },
                        }}
                      />
                    ))}
                  </Box>
                </Paper>
              </Box>
            )}
            <div ref={sdEndRef} />
          </Box>

          {/* Word count */}
          {sdMsg && (
            <Typography
              variant="caption"
              sx={{
                px: 2,
                pb: 0.5,
                textAlign: "right",
                display: "block",
                color:
                  sdMsg.trim().split(/\s+/).length > 1500
                    ? "#ef4444"
                    : "#94a3b8",
                bgcolor: isDarkMode ? "#1e293b" : "#fff",
              }}
            >
              {sdMsg.trim().split(/\s+/).length} / 1500 words
            </Typography>
          )}

          {/* Input */}
          <Box
            sx={{
              p: 1.25,
              borderTop: `0.5px solid ${
                isDarkMode ? "#334155" : "rgba(0,0,0,0.08)"
              }`,
              display: "flex",
              gap: 1,
              alignItems: "flex-end",
              bgcolor: isDarkMode ? "#1e293b" : "#fff",
              flexShrink: 0,
            }}
          >
            <TextField
              fullWidth
              multiline
              maxRows={3}
              size="small"
              placeholder="Type your message… (Enter to send)"
              value={sdMsg}
              onChange={(e) => setSdMsg(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && !e.shiftKey) {
                  e.preventDefault();
                  sdSend();
                }
              }}
              disabled={sdLoading}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: 3,
                  fontSize: "0.8rem",
                  bgcolor: isDarkMode ? "#0f172a" : "#f8fafc",
                },
              }}
            />
            <IconButton
              onClick={() => sdSend()}
              disabled={!sdMsg.trim() || sdLoading}
              sx={{
                width: 36,
                height: 36,
                borderRadius: "50%",
                flexShrink: 0,
                mb: "2px",
                background:
                  sdMsg.trim() && !sdLoading
                    ? "linear-gradient(135deg,#667eea,#764ba2)"
                    : "rgba(0,0,0,0.1)",
                color: sdMsg.trim() && !sdLoading ? "white" : "#94a3b8",
                "&:hover:not(:disabled)": { transform: "scale(1.08)" },
                "&:disabled": { background: "rgba(0,0,0,0.1)" },
              }}
            >
              <Send sx={{ fontSize: 16 }} />
            </IconButton>
          </Box>
        </Dialog>
      </Box>

      {/* ── Wave FAB ── */}
      <Box
        sx={{
          position: "fixed",
          top: 30,
          right: 28,
          width: 60,
          height: 60,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1400,
        }}
      >
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            sx={{
              position: "absolute",
              width: 60,
              height: 60,
              borderRadius: "50%",
              border: "2.5px solid rgba(102,126,234,0.5)",
              animation: "sdWave 2s ease-out infinite",
              animationDelay: `${i * 0.6}s`,
              "@keyframes sdWave": {
                "0%": { transform: "scale(1)", opacity: 0.8 },
                "100%": { transform: "scale(2.3)", opacity: 0 },
              },
            }}
          />
        ))}
        <LightTooltip title="AI SmartDesk" placement="left">
          <Box
            onClick={() => setSdOpen(true)}
            sx={{
              position: "relative",
              zIndex: 2,
              width: 60,
              height: 60,
              borderRadius: "50%",
              background: "linear-gradient(135deg,#667eea,#764ba2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              animation: "sdPulse 3s ease-in-out infinite",
              "@keyframes sdPulse": {
                "0%,100%": { transform: "scale(1)" },
                "50%": { transform: "scale(1.07)" },
              },
              "&:hover": {
                transform: "scale(1.12) !important",
                boxShadow: "0 8px 24px rgba(102,126,234,0.5)",
              },
              transition: "box-shadow .2s",
            }}
          >
            <Psychology sx={{ color: "white", fontSize: 28 }} />
          </Box>
        </LightTooltip>
      </Box>

      {/* ── SmartDesk Center Dialog ── */}
      <Dialog
        open={sdOpen}
        onClose={() => {
          setSdOpen(false);
          setSdEditingId(null);
        }}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: 480,
            height: 600,
            borderRadius: 4,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            background: isDarkMode ? "#1e293b" : "#fff",
            boxShadow: "0 32px 80px rgba(0,0,0,0.22)",
          },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            px: 2,
            py: 1.5,
            background: "linear-gradient(135deg,#667eea,#764ba2)",
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            flexShrink: 0,
          }}
        >
          <Avatar
            sx={{ bgcolor: "rgba(255,255,255,0.2)", width: 38, height: 38 }}
          >
            <Psychology sx={{ fontSize: 22, color: "white" }} />
          </Avatar>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="subtitle1"
              sx={{
                color: "white",
                fontWeight: 600,
                lineHeight: 1.2,
                fontSize: "0.9rem",
              }}
            >
              AI SmartDesk
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: "rgba(255,255,255,0.85)",
                display: "flex",
                alignItems: "center",
                gap: 0.5,
              }}
            >
              <Box
                sx={{
                  width: 7,
                  height: 7,
                  borderRadius: "50%",
                  bgcolor: "#4ade80",
                  display: "inline-block",
                }}
              />
              Online · Ready to assist
            </Typography>
          </Box>
          <IconButton
            size="small"
            onClick={() => {
              setSdOpen(false);
              setSdEditingId(null);
            }}
            sx={{
              bgcolor: "rgba(255,255,255,0.18)",
              color: "white",
              "&:hover": { bgcolor: "rgba(255,255,255,0.3)" },
              width: 30,
              height: 30,
            }}
          >
            <CloseIcon sx={{ fontSize: 15 }} />
          </IconButton>
        </Box>

        {/* Messages */}
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            p: 1.75,
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            bgcolor: isDarkMode ? "#0f172a" : "#f8fafc",
            "&::-webkit-scrollbar": { width: 4 },
            "&::-webkit-scrollbar-thumb": {
              bgcolor: "rgba(102,126,234,0.25)",
              borderRadius: 4,
            },
          }}
        >
          {sdConv.length === 0 && !sdLoading ? (
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 1.5,
                textAlign: "center",
                py: 3,
                minHeight: 320,
              }}
            >
              <Box
                sx={{
                  width: 58,
                  height: 58,
                  borderRadius: 3,
                  bgcolor: "rgba(102,126,234,0.09)",
                  border: "1px solid rgba(102,126,234,0.18)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Psychology sx={{ fontSize: 28, color: "#667eea" }} />
              </Box>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  color: isDarkMode ? "white" : "#0f172a",
                }}
              >
                Hello! I'm your AI assistant
              </Typography>
              <Typography
                variant="caption"
                sx={{ color: "#64748b", maxWidth: 210, lineHeight: 1.6 }}
              >
                Ask me anything or pick a quick prompt
              </Typography>
            </Box>
          ) : (
            sdConv.map((msg) => {
              const isUser = msg.type === "user";
              const isEditing = sdEditingId === msg.id;
              return (
                <Box
                  key={msg.id}
                  sx={{
                    display: "flex",
                    justifyContent: isUser ? "flex-end" : "flex-start",
                    gap: 1,
                    alignItems: "flex-end",
                  }}
                >
                  {!isUser && (
                    <Avatar
                      sx={{
                        width: 28,
                        height: 28,
                        bgcolor: "#764ba2",
                        fontSize: "0.62rem",
                        fontWeight: 700,
                      }}
                    >
                      AI
                    </Avatar>
                  )}
                  <Box sx={{ maxWidth: "72%" }}>
                    <Paper
                      elevation={0}
                      sx={{
                        px: 1.5,
                        py: 1,
                        fontSize: "0.8rem",
                        lineHeight: 1.65,
                        whiteSpace: "pre-wrap",
                        borderRadius: isUser
                          ? "14px 4px 14px 14px"
                          : "4px 14px 14px 14px",
                        background: isUser
                          ? "linear-gradient(135deg,#667eea,#764ba2)"
                          : isDarkMode
                          ? "#1e293b"
                          : "#fff",
                        color: isUser
                          ? "white"
                          : isDarkMode
                          ? "#e2e8f0"
                          : "#0f172a",
                        border: !isUser
                          ? `0.5px solid ${
                              isDarkMode ? "#334155" : "rgba(0,0,0,0.09)"
                            }`
                          : "none",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: "0.8rem",
                          lineHeight: 1.65,
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        {msg.content}
                        {msg.edited && (
                          <Box
                            component="span"
                            sx={{
                              fontSize: "0.65rem",
                              color: isUser
                                ? "rgba(255,255,255,0.7)"
                                : "#f59e0b",
                              ml: 0.5,
                            }}
                          >
                            (edited)
                          </Box>
                        )}
                      </Typography>
                    </Paper>

                    {/* Edit box for user msgs */}
                    {isEditing && (
                      <Box
                        sx={{
                          mt: 0.75,
                          p: 1.25,
                          bgcolor: "#fffbf0",
                          border: "1px solid #fcd34d",
                          borderRadius: 2,
                        }}
                      >
                        <TextField
                          fullWidth
                          multiline
                          rows={3}
                          size="small"
                          value={sdEditContent}
                          onChange={(e) => setSdEditContent(e.target.value)}
                          sx={{
                            mb: 1,
                            "& .MuiOutlinedInput-root": {
                              fontSize: "0.78rem",
                              borderRadius: 2,
                            },
                          }}
                        />
                        <Stack
                          direction="row"
                          spacing={0.75}
                          justifyContent="flex-end"
                        >
                          <Button
                            size="small"
                            onClick={() => {
                              setSdEditingId(null);
                              setSdEditContent("");
                            }}
                            sx={{
                              fontSize: "0.72rem",
                              color: "#64748b",
                              borderColor: "rgba(0,0,0,0.15)",
                            }}
                            variant="outlined"
                          >
                            Cancel
                          </Button>
                          <Button
                            size="small"
                            onClick={sdSaveEdit}
                            variant="contained"
                            sx={{
                              fontSize: "0.72rem",
                              background: "#667eea",
                              "&:hover": { background: "#5a6fd6" },
                            }}
                          >
                            Save & resend
                          </Button>
                        </Stack>
                      </Box>
                    )}

                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: "0.65rem",
                        color: "#94a3b8",
                        display: "block",
                        mt: 0.3,
                        textAlign: isUser ? "right" : "left",
                      }}
                    >
                      {msg.ts.toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </Typography>

                    {/* Action icons */}
                    <Box
                      sx={{
                        display: "flex",
                        gap: 0.5,
                        mt: 0.4,
                        justifyContent: isUser ? "flex-end" : "flex-start",
                        opacity: 1,
                        transition: "opacity .15s",
                        "&:hover": { opacity: 1 },
                      }}
                    >
                      {isUser && (
                        <LightTooltip title="Edit message">
                          <IconButton
                            size="small"
                            onClick={() => {
                              setSdEditingId(msg.id);
                              setSdEditContent(msg.content);
                            }}
                            sx={{
                              width: 24,
                              height: 24,
                              borderRadius: 1,
                              bgcolor: "rgba(102,126,234,0.1)",
                              "&:hover": {
                                bgcolor: "rgba(102,126,234,0.22)",
                              },
                            }}
                          >
                            <Edit sx={{ fontSize: 13, color: "#667eea" }} />
                          </IconButton>
                        </LightTooltip>
                      )}
                      <LightTooltip
                        title={isUser ? "Copy message" : "Copy response"}
                      >
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            navigator.clipboard.writeText(msg.content);
                            const btn = e.currentTarget;
                            btn.style.background = "rgba(16,185,129,0.2)";
                            setTimeout(
                              () => (btn.style.background = ""),
                              1800
                            );
                            setSuccessMessage(
                              isUser ? "Message copied!" : "Response copied!"
                            );
                            setShowSuccess(true);
                          }}
                          sx={{
                            width: 24,
                            height: 24,
                            borderRadius: 1,
                            bgcolor: "rgba(16,185,129,0.1)",
                            "&:hover": { bgcolor: "rgba(16,185,129,0.22)" },
                          }}
                        >
                          <ContentCopy
                            sx={{ fontSize: 13, color: "#10b981" }}
                          />
                        </IconButton>
                      </LightTooltip>
                    </Box>
                  </Box>
                  {isUser && (
                    <Avatar
                      sx={{
                        width: 28,
                        height: 28,
                        bgcolor: "#667eea",
                        fontSize: "0.62rem",
                        fontWeight: 700,
                      }}
                    >
                      U
                    </Avatar>
                  )}
                </Box>
              );
            })
          )}

          {sdLoading && (
            <Box sx={{ display: "flex", gap: 1, alignItems: "flex-end" }}>
              <Avatar
                sx={{
                  width: 28,
                  height: 28,
                  bgcolor: "#764ba2",
                  fontSize: "0.62rem",
                  fontWeight: 700,
                }}
              >
                AI
              </Avatar>
              <Paper
                elevation={0}
                sx={{
                  px: 1.5,
                  py: 1,
                  borderRadius: "4px 14px 14px 14px",
                  bgcolor: isDarkMode ? "#1e293b" : "#fff",
                  border: `0.5px solid ${
                    isDarkMode ? "#334155" : "rgba(0,0,0,0.09)"
                  }`,
                }}
              >
                <Box sx={{ display: "flex", gap: 0.6, alignItems: "center" }}>
                  {[0, 1, 2].map((i) => (
                    <Box
                      key={i}
                      sx={{
                        width: 7,
                        height: 7,
                        borderRadius: "50%",
                        bgcolor: "#a855f7",
                        animation: "sdBounce 1.2s infinite",
                        animationDelay: `${i * 0.18}s`,
                        "@keyframes sdBounce": {
                          "0%,60%,100%": { transform: "translateY(0)" },
                          "30%": { transform: "translateY(-5px)" },
                        },
                      }}
                    />
                  ))}
                </Box>
              </Paper>
            </Box>
          )}
          <div ref={sdEndRef} />
        </Box>

        {/* Word count */}
        {sdMsg && (
          <Typography
            variant="caption"
            sx={{
              px: 2,
              pb: 0.5,
              textAlign: "right",
              display: "block",
              color:
                sdMsg.trim().split(/\s+/).length > 1500
                  ? "#ef4444"
                  : "#94a3b8",
              bgcolor: isDarkMode ? "#1e293b" : "#fff",
            }}
          >
            {sdMsg.trim().split(/\s+/).length} / 1500 words
          </Typography>
        )}

        {/* Input */}
        <Box
          sx={{
            p: 1.25,
            borderTop: `0.5px solid ${
              isDarkMode ? "#334155" : "rgba(0,0,0,0.08)"
            }`,
            display: "flex",
            gap: 1,
            alignItems: "flex-end",
            bgcolor: isDarkMode ? "#1e293b" : "#fff",
            flexShrink: 0,
          }}
        >
          <TextField
            fullWidth
            multiline
            maxRows={3}
            size="small"
            placeholder="Type your message… (Enter to send)"
            value={sdMsg}
            onChange={(e) => setSdMsg(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                sdSend();
              }
            }}
            disabled={sdLoading}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 3,
                fontSize: "0.8rem",
                bgcolor: isDarkMode ? "#0f172a" : "#f8fafc",
              },
            }}
          />
          <IconButton
            onClick={() => sdSend()}
            disabled={!sdMsg.trim() || sdLoading}
            sx={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              flexShrink: 0,
              mb: "2px",
              background:
                sdMsg.trim() && !sdLoading
                  ? "linear-gradient(135deg,#667eea,#764ba2)"
                  : "rgba(0,0,0,0.1)",
              color: sdMsg.trim() && !sdLoading ? "white" : "#94a3b8",
              "&:hover:not(:disabled)": { transform: "scale(1.08)" },
              "&:disabled": { background: "rgba(0,0,0,0.1)" },
            }}
          >
            <Send sx={{ fontSize: 16 }} />
          </IconButton>
        </Box>
      </Dialog>
    </>
  );
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  features: state.features.features,
});

export default connect(mapStateToProps)(NewParaphrase);
